export const ENV_KEYS = {
  ApiUrl: "VITE_SERVICE_API_URL",
  BuildVersion: "VITE_BUILD_VERSION",
  SensepassMode: "VITE_SENSEPASS_MODE",
  SensepassDebug: "VITE_SENSEPASS_DEBUG",
  SensepassClientId: "VITE_SENSEPASS_CLIENT_ID",
  CognitoUserPoolId: "VITE_COGNITO_USER_POOL_ID",
  CognitoClientId: "VITE_COGNITO_CLIENT_ID",
  CognitoRegion: "VITE_COGNITO_REGION",
  CognitoDomain: "VITE_COGNITO_DOMAIN",
  OktaOidcProvider: "VITE_OKTA_OIDC_PROVIDER",
  CognitoRefreshTokenLifetimeMinutes: "VITE_COGNITO_REFRESH_TOKEN_LIFETIME_MINUTES",
} as const;

export function getEnvValue(
  key: (typeof ENV_KEYS)[keyof typeof ENV_KEYS]
): any {
  const value = (window.env ? window.env[key] : null) ?? import.meta.env[key];
  if (!value && key === ENV_KEYS.ApiUrl) return window.location.origin + "/api";
  return value;
}

export default { getEnvValue, ENV_KEYS };
